export default __webpack_public_path__ + "assets/images/3338fbb438971311419bb1111e211ac4.jpg";